import React from 'react';
import { Link } from 'react-router-dom';
import { MainImage } from '../../../../Shared/Content/ProductDetail/ProductMainImage/ProductMainImage';
import { Title } from '../../../../Shared/Content/ProductDetail/ProductTitle/ProductTitle';
import { ItemNumber } from '../../../../Shared/Content/ProductDetail/ProductItemNumber/ProductItemNumber';
import { CloseXIcon } from '../../../../../UI/Icons/Icons';
import SetInnerHTML from '../../../../../UI/SetInnerHTML/SetInnerHTML';

export class QuickViewOldProduct extends React.Component {
  render() {
    var mainImageSize = {
      mainImgWidth: 390,
      mainImgHeight: 452,
    };
    return (
      <section id='QuickViewDisplay'>
        <div className='row m-0'>
          <div className='col-sm-12'>
            <button type='button' className='close btn-tertiary' onClick={this.props.passedAppFunctions.closeQuickView}>
              <CloseXIcon />
            </button>
          </div>
          <div className='col-sm-6 p-0'>
            <MainImage
              contentData={this.props.contentData}
              selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
              passedAppFunctions={this.props.passedAppFunctions}
              mainImgWidth={mainImageSize.mainImgWidth}
              mainImgHeight={mainImageSize.mainImgHeight}
            />
          </div>
          <div className='col-sm-5 m-0 p-0'>
            <Title contentData={this.props.contentData} passedAppFunctions={this.props.passedAppFunctions} />
            <ItemNumber contentData={this.props.contentData} />
            <div>
              <Link to={`/brand/${this.props.contentData.personalization.urlFormattedBrandName}`}>
                <button type='button' className='btn btn-secondary btn-block'>
                  Shop All {this.props.contentData.personalization.brandName} &gt;
                </button>
              </Link>
              <div id='error-message' className='alert alert-danger' role='alert'>
                <SetInnerHTML innerHTML={this.props.contentData.unavailableMessage} />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default QuickViewOldProduct;
